import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Content from "../../../Components/Dashboard/Content/Content";
import Formikform from "../../../Components/ExtraComponents/Form/Formik_form1";
import * as valid_err from "../../../Utils/Common_Messages";
import { useFormik } from "formik";
import { Add_Panel_data } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import { useDispatch } from "react-redux";
import { Get_All_Theme_Name } from "../../../ReduxStore/Slice/ThemeSlice";
import { All_Brokers } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import toast from "react-hot-toast";

const Add_Panel = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_token = JSON.parse(localStorage.getItem("user_details")).token;

  const UserName = JSON.parse(localStorage.getItem("user_details")).UserName;

  const formik = useFormik({
    initialValues: {
      panel_name: "",
      domain: "",
      port: "7700",
      key: "",
      ip_address: "",
      is_active: 1,
      is_expired: 0,
      db_url: "",
      db_name: "test",

      backend_rul: "",
      InvoicePermission: false,
      Create_Strategy: false,
      AddClient: false,
      sevant_day: false,
    },
    validate: (values) => {
      const errors = {};

      // Check if panel_name is empty
      if (!values.panel_name) {
        errors.panel_name = valid_err.PANEL_NAME_ERROR;
      }

      // Check if domain is empty
      if (!values.domain) {
        errors.domain = valid_err.DOMAIN_ERROR;
      }

      // Check if port is empty
      if (!values.port) {
        errors.port = "Port is required";
      }

      // Check if key is empty
      if (!values.key) {
        errors.key = valid_err.KEY_ERROR;
      }

      // Check if ip_address is empty
      if (!values.ip_address) {
        errors.ip_address = "IP Address is required";
      }

      // Check if db_name is empty
      if (!values.db_name) {
        errors.db_name = "Database name is required";
      }

      return errors;
    },
    onSubmit: async (values) => {
      const trimmedValues = {
        panel_name: values.panel_name.trim(),
        domain: values.domain.trim(),
        port: values.port.trim(),
        key: values.key.trim(),
        ip_address: values.ip_address.trim(),
        db_url: values.db_url.trim(),
        db_name: values.db_name.trim(),

        backend_rul: values.domain.trim() + "/backend/",
        UserName: UserName.trim(),
        
        Create_Strategy: values.Create_Strategy ? 1 : 0,
        AddClient: values.AddClient ? 1 : 0,
        sevant_day: values.sevant_day ? 1 : 0,
        InvoicePermission: values.InvoicePermission ? 1 : 0,
      };

      await dispatch(Add_Panel_data({ req: trimmedValues, token: user_token }))
        .unwrap()
        .then((response) => {
          if (response.status === 409) {
            toast.error(response.data.msg);
          } else if (response.status) {
            toast.success(response.msg);
            setTimeout(() => {
              navigate("/super/alladmins");
            }, 1000);
          } else if (!response.status) {
            toast.error(response.msg);
          }
        });
    },
  });

  const fields = [
    {
      name: "panel_name",
      label: "Panel Name",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "Pandpinfotech",
    },
    {
      name: "domain",
      label: "Domain",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "https://newpenal.deepmindinfotech.com",
    },
    {
      name: "key",
      label: "Key",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "SNE132023",
    },
    {
      name: "ip_address",
      label: "Ip Address",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "193.239.237.136",
    },

    {
      name: "db_url",
      label: "Database Url",
      type: "placeholder",
      label_size: 12,
      col_size: 12,
      placeholderdata:
        "mongodb://pnpinfotech:p%26k56%267GsRy%26vnd%26@193.239.237.136:27017/",
    },
    {
      name: "Create_Strategy",
      label: "Create Strategy",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.Create_Strategy ? true : false,
    },
    {
      name: "AddClient",
      label: "Add Client",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.AddClient ? true : false,
    },
    {
      name: "sevant_day",
      label: "7 Day Client",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.sevant_day ? true : false,
    },
    {
      name: "InvoicePermission",
      label: "Invoice Permission",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.InvoicePermission ? true : false,
    },
  ];

  return (
    <Content
      Page_title="Add Panel"
      button_title="Back"
      route="/super/alladmins"
    >
      <Formikform
        fieldtype={fields.filter((field) => !field.showWhen)}
        formik={formik}
        btn_name="Add Panel"
      />
      <ToastButton />
    </Content>
  );
};

export default Add_Panel;
